/* eslint-disable no-underscore-dangle */
import React from 'react';
import classnames from 'classnames/bind';
import { ColorPresets } from '@/types/whiteboard';
import Style from './index.less';

const $c = classnames.bind(Style);
interface Props {
  color: ColorPresets;
  onChange(event: { color: ColorPresets }): void;
}

const ColorPalette: React.FC<Props> = (props: Props) => {
  const { color, onChange } = props;
  return (
    <div className={$c('color-palette')}>
      {[
        ColorPresets.BLACK,
        ColorPresets.WHITE,
        ColorPresets.RED,
        ColorPresets.YELLOW,
        ColorPresets.BLUE,
        ColorPresets.GREEN,
        ColorPresets.PURPLE,
        ColorPresets.ORANGE,
      ].map(c => (
        <div
          key={c}
          className={$c('click', { selected: color === c })}
          onClick={() => {
            onChange?.({
              color: c,
            });
          }}
        >
          <div style={{ backgroundColor: c }} />
        </div>
      ))}
    </div>
  );
};

export default ColorPalette;
